import React from 'react';
import './Userface.css';
import { PersonaSize, Facepile } from '@fluentui/react';

const personProps = () => {
    return {
        hidePersonaDetails: true,
    };
};

const userFace = (props) => {
    const setInitials = (name) => {
        return String(name.charAt(0)).toUpperCase() + name.charAt(1);
    };

    const personaSize = PersonaSize.size24;
    const persona = {
        imageInitials: setInitials(props.username),
        personaName: props.username,
        initialsColor: 0,
    };

    return (
        <div className="userface-content">
            <Facepile
                personaSize={personaSize}
                personas={[persona]}
                getPersonaProps={personProps}
            />
        </div>
    );
};

export default userFace;
